import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0
    
}
const mutations={
   
  
    getMyorderData(state,value){
        
        
       
        post(urls.admin.order.index,value).then((result)=>{
          
    
          
          state.result=result

        
        
       
        
       
           
        });
        
    },
    getMyorderDetail(state,value){
        
        
       
        post(urls.admin.order.detail,value).then((result)=>{
          
          
          
          state.result=result
        
       
        
       
           
        });
        
    },
  
    getorderAllData(state,value){
        
        
       
        post(urls.admin.order.all_index,value).then((result)=>{
          
          
          
          state.result=result

        
        
       
        
       
           
        });
        
    },

    editorderData(state,value){



        post(urls.admin.order.edit,value).then((result)=>{



            state.result=result







        });

    },


}
const  actions={
    getMyorderDataAction(context,value){
       
        context.commit("getMyorderData",value)
       
    },
    getMyorderDetailAction(context,value){
       
        context.commit("getMyorderDetail",value)
       
    },
  
    getorderAllDataAction(context,value){
       
        context.commit("getorderAllData",value)
       
    },
    editorderDataAction(context,value){

        context.commit("editorderData",value)

    },
    
   

}

export default {state,mutations,actions}